import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-16-right",
  "use": "icon-icon-16-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon-16-right\"><path d=\"M4.815 13.339a1 1 0 0 0 1.414 0l5.303-5.303a.5.5 0 0 0 0-.708L6.23 2.025A1 1 0 0 0 4.815 3.44l3.888 3.889a.5.5 0 0 1 0 .707l-3.888 3.89a1 1 0 0 0 0 1.414z\" fill=\"#29A360\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol